/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  InvalidateQueryFilters,
  OperationError,
  OperationInfiniteData,
  PartialParameters,
  QraftServiceOperationsToken,
  QueryFiltersByParameters,
  QueryFiltersByQueryKey,
  QueryFnOptionsByParameters,
  QueryFnOptionsByQueryKey,
  RequestFnResponse,
  ServiceOperationEnsureInfiniteQueryDataOptions,
  ServiceOperationEnsureQueryDataOptions,
  ServiceOperationFetchInfiniteQueryOptions,
  ServiceOperationFetchQueryOptions,
  ServiceOperationInfiniteQueryKey,
  ServiceOperationQueryKey,
  UseQueryOptionsForUseQueries,
  UseQueryOptionsForUseSuspenseQuery,
  WithOptional,
} from '@openapi-qraft/tanstack-query-react-types';
import type {
  CancelOptions,
  DefinedInitialDataInfiniteOptions,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteQueryPageParamsOptions,
  InvalidateOptions,
  NoInfer,
  QueryState,
  RefetchOptions,
  ResetOptions,
  SetDataOptions,
  UndefinedInitialDataInfiniteOptions,
  UndefinedInitialDataOptions,
  Updater,
  UseInfiniteQueryResult,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type { paths } from '../schema';

export interface LocationsService {
  /**
   * @summary Get
   * @description Retrieves a single location by its ID.
   */
  getLocationsLocationIdGet: {
    /**
     * @summary Get
     * @description Retrieves a single location by its ID.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<GetLocationsLocationIdGetSchema, GetLocationsLocationIdGetParameters, TMeta, TSignal>
        | QueryFnOptionsByParameters<GetLocationsLocationIdGetParameters, TMeta, TSignal>,
      client?: (
        schema: GetLocationsLocationIdGetSchema,
        options: {
          parameters: GetLocationsLocationIdGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<GetLocationsLocationIdGetData, GetLocationsLocationIdGetError>>
    ): Promise<RequestFnResponse<GetLocationsLocationIdGetData, GetLocationsLocationIdGetError>>;
    /**
     * @summary Get
     * @description Retrieves a single location by its ID.
     */
    getQueryKey(
      parameters: DeepReadonly<GetLocationsLocationIdGetParameters>
    ): ServiceOperationQueryKey<GetLocationsLocationIdGetSchema, GetLocationsLocationIdGetParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get
     * @description Retrieves a single location by its ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.locationsService.getLocationsLocationIdGet.useQuery({
     *     path: {
     *         location_id: locationId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetLocationsLocationIdGetData>(
      parameters:
        | ServiceOperationQueryKey<GetLocationsLocationIdGetSchema, GetLocationsLocationIdGetParameters>
        | DeepReadonly<GetLocationsLocationIdGetParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          GetLocationsLocationIdGetData,
          GetLocationsLocationIdGetError,
          TData,
          ServiceOperationQueryKey<GetLocationsLocationIdGetSchema, GetLocationsLocationIdGetParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetLocationsLocationIdGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get
     * @description Retrieves a single location by its ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.locationsService.getLocationsLocationIdGet.useQuery({
     *     path: {
     *         location_id: locationId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetLocationsLocationIdGetData>(
      parameters:
        | ServiceOperationQueryKey<GetLocationsLocationIdGetSchema, GetLocationsLocationIdGetParameters>
        | DeepReadonly<GetLocationsLocationIdGetParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          GetLocationsLocationIdGetData,
          GetLocationsLocationIdGetError,
          TData,
          ServiceOperationQueryKey<GetLocationsLocationIdGetSchema, GetLocationsLocationIdGetParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetLocationsLocationIdGetError>>;
    /**
     * @summary Get
     * @description Retrieves a single location by its ID.
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetLocationsLocationIdGetParameters>
    ): ServiceOperationInfiniteQueryKey<GetLocationsLocationIdGetSchema, GetLocationsLocationIdGetParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get
     * @description Retrieves a single location by its ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.locationsService.getLocationsLocationIdGet.useInfiniteQuery({
     *     path: {
     *         location_id: locationId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetLocationsLocationIdGetParameters,
      TQueryFnData = GetLocationsLocationIdGetData,
      TData = OperationInfiniteData<TQueryFnData, GetLocationsLocationIdGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetLocationsLocationIdGetSchema, GetLocationsLocationIdGetParameters>
        | DeepReadonly<GetLocationsLocationIdGetParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetLocationsLocationIdGetError,
          TData,
          ServiceOperationInfiniteQueryKey<GetLocationsLocationIdGetSchema, GetLocationsLocationIdGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetLocationsLocationIdGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get
     * @description Retrieves a single location by its ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.locationsService.getLocationsLocationIdGet.useInfiniteQuery({
     *     path: {
     *         location_id: locationId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetLocationsLocationIdGetParameters,
      TQueryFnData = GetLocationsLocationIdGetData,
      TData = OperationInfiniteData<TQueryFnData, GetLocationsLocationIdGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetLocationsLocationIdGetSchema, GetLocationsLocationIdGetParameters>
        | DeepReadonly<GetLocationsLocationIdGetParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetLocationsLocationIdGetError,
          TData,
          ServiceOperationInfiniteQueryKey<GetLocationsLocationIdGetSchema, GetLocationsLocationIdGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetLocationsLocationIdGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetLocationsLocationIdGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get
     * @description Retrieves a single location by its ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getLocationsLocationIdGetTotal = qraft.locationsService.getLocationsLocationIdGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const getLocationsLocationIdGetByParametersTotal = qraft.locationsService.getLocationsLocationIdGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         path: {
     *             location_id: locationId
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetLocationsLocationIdGetSchema,
            GetLocationsLocationIdGetData,
            TInfinite,
            GetLocationsLocationIdGetParameters,
            GetLocationsLocationIdGetError
          >
        | QueryFiltersByQueryKey<
            GetLocationsLocationIdGetSchema,
            GetLocationsLocationIdGetData,
            TInfinite,
            GetLocationsLocationIdGetParameters,
            GetLocationsLocationIdGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get
     * @description Retrieves a single location by its ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getLocationsLocationIdGetResults = qraft.locationsService.getLocationsLocationIdGet.useQueries({
     *     queries: [
     *         {
     *             path: {
     *                 location_id: locationId1
     *             }
     *         },
     *         {
     *             path: {
     *                 location_id: locationId2
     *             }
     *         }
     *     ]
     * });
     * getLocationsLocationIdGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getLocationsLocationIdGetCombinedResults = qraft.locationsService.getLocationsLocationIdGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 location_id: locationId1
     *             }
     *         },
     *         {
     *             path: {
     *                 location_id: locationId2
     *             }
     *         }
     *     ]
     * });
     * getLocationsLocationIdGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetLocationsLocationIdGetSchema,
          GetLocationsLocationIdGetParameters,
          GetLocationsLocationIdGetData,
          GetLocationsLocationIdGetError
        >
      >,
      TCombinedResult = Array<UseQueryResult<GetLocationsLocationIdGetData, GetLocationsLocationIdGetError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<UseQueryResult<GetLocationsLocationIdGetData, GetLocationsLocationIdGetError>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get
     * @description Retrieves a single location by its ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.locationsService.getLocationsLocationIdGet.useSuspenseQuery({
     *     path: {
     *         location_id: locationId
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = GetLocationsLocationIdGetData>(
      parameters:
        | ServiceOperationQueryKey<GetLocationsLocationIdGetSchema, GetLocationsLocationIdGetParameters>
        | DeepReadonly<GetLocationsLocationIdGetParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          GetLocationsLocationIdGetData,
          GetLocationsLocationIdGetError,
          TData,
          ServiceOperationQueryKey<GetLocationsLocationIdGetSchema, GetLocationsLocationIdGetParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetLocationsLocationIdGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get
     * @description Retrieves a single location by its ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.locationsService.getLocationsLocationIdGet.useSuspenseInfiniteQuery({
     *     path: {
     *         location_id: locationId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends GetLocationsLocationIdGetParameters,
      TData = GetLocationsLocationIdGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetLocationsLocationIdGetSchema, GetLocationsLocationIdGetParameters>
        | DeepReadonly<GetLocationsLocationIdGetParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetLocationsLocationIdGetData,
          GetLocationsLocationIdGetError,
          OperationInfiniteData<TData, GetLocationsLocationIdGetParameters>,
          ServiceOperationInfiniteQueryKey<GetLocationsLocationIdGetSchema, GetLocationsLocationIdGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetLocationsLocationIdGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetLocationsLocationIdGetParameters>,
      OperationError<GetLocationsLocationIdGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get
     * @description Retrieves a single location by its ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getLocationsLocationIdGetData = qraft.locationsService.getLocationsLocationIdGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             path: {
     *                 location_id: locationId1
     *             }
     *         },
     *         {
     *             path: {
     *                 location_id: locationId2
     *             }
     *         }
     *     ]
     * });
     * getLocationsLocationIdGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getLocationsLocationIdGetCombinedData = qraft.locationsService.getLocationsLocationIdGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 location_id: locationId1
     *             }
     *         },
     *         {
     *             path: {
     *                 location_id: locationId2
     *             }
     *         }
     *     ]
     * });
     * getLocationsLocationIdGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetLocationsLocationIdGetSchema,
          GetLocationsLocationIdGetParameters,
          GetLocationsLocationIdGetData,
          GetLocationsLocationIdGetError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<GetLocationsLocationIdGetData, GetLocationsLocationIdGetError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<UseSuspenseQueryResult<GetLocationsLocationIdGetData, GetLocationsLocationIdGetError>, 'data'>
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary Get
     * @description Retrieves a single location by its ID.
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetLocationsLocationIdGetSchema,
        GetLocationsLocationIdGetData,
        GetLocationsLocationIdGetParameters,
        GetLocationsLocationIdGetError
      >
    ): Promise<GetLocationsLocationIdGetData>;
    /**
     * @summary Get
     * @description Retrieves a single location by its ID.
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetLocationsLocationIdGetSchema,
        GetLocationsLocationIdGetData,
        GetLocationsLocationIdGetParameters,
        GetLocationsLocationIdGetError
      >
    ): Promise<void>;
    /**
     * @summary Get
     * @description Retrieves a single location by its ID.
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetLocationsLocationIdGetSchema,
        GetLocationsLocationIdGetData,
        GetLocationsLocationIdGetParameters,
        GetLocationsLocationIdGetError
      >
    ): Promise<GetLocationsLocationIdGetData>;
    /**
     * @summary Get
     * @description Retrieves a single location by its ID.
     */
    fetchInfiniteQuery<TPageParam extends GetLocationsLocationIdGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetLocationsLocationIdGetSchema,
        GetLocationsLocationIdGetData,
        GetLocationsLocationIdGetParameters,
        DeepReadonly<TPageParam>,
        GetLocationsLocationIdGetError
      >
    ): Promise<OperationInfiniteData<GetLocationsLocationIdGetData, GetLocationsLocationIdGetParameters>>;
    /**
     * @summary Get
     * @description Retrieves a single location by its ID.
     */
    prefetchInfiniteQuery<TPageParam extends GetLocationsLocationIdGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetLocationsLocationIdGetSchema,
        GetLocationsLocationIdGetData,
        GetLocationsLocationIdGetParameters,
        DeepReadonly<TPageParam>,
        GetLocationsLocationIdGetError
      >
    ): Promise<void>;
    /**
     * @summary Get
     * @description Retrieves a single location by its ID.
     */
    ensureInfiniteQueryData<TPageParam extends GetLocationsLocationIdGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetLocationsLocationIdGetSchema,
        GetLocationsLocationIdGetData,
        GetLocationsLocationIdGetParameters,
        DeepReadonly<TPageParam>,
        GetLocationsLocationIdGetError
      >
    ): Promise<OperationInfiniteData<GetLocationsLocationIdGetData, GetLocationsLocationIdGetParameters>>;
    /**
     * @summary Get
     * @description Retrieves a single location by its ID.
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<GetLocationsLocationIdGetSchema, GetLocationsLocationIdGetParameters>
        | DeepReadonly<GetLocationsLocationIdGetParameters>
    ): GetLocationsLocationIdGetData | undefined;
    /**
     * @summary Get
     * @description Retrieves a single location by its ID.
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetLocationsLocationIdGetSchema, GetLocationsLocationIdGetParameters>
        | DeepReadonly<GetLocationsLocationIdGetParameters>
    ): OperationInfiniteData<GetLocationsLocationIdGetData, GetLocationsLocationIdGetParameters> | undefined;
    /**
     * @summary Get
     * @description Retrieves a single location by its ID.
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetLocationsLocationIdGetSchema,
            GetLocationsLocationIdGetData,
            TInfinite,
            GetLocationsLocationIdGetParameters,
            GetLocationsLocationIdGetError
          >
        | QueryFiltersByQueryKey<
            GetLocationsLocationIdGetSchema,
            GetLocationsLocationIdGetData,
            TInfinite,
            GetLocationsLocationIdGetParameters,
            GetLocationsLocationIdGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              GetLocationsLocationIdGetSchema,
              GetLocationsLocationIdGetParameters
            >,
            data:
              | NoInfer<OperationInfiniteData<GetLocationsLocationIdGetData, GetLocationsLocationIdGetParameters>>
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<GetLocationsLocationIdGetSchema, GetLocationsLocationIdGetParameters>,
            data: GetLocationsLocationIdGetData | undefined,
          ]
        >;
    /**
     * @summary Get
     * @description Retrieves a single location by its ID.
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<GetLocationsLocationIdGetSchema, GetLocationsLocationIdGetParameters>
        | DeepReadonly<GetLocationsLocationIdGetParameters>
    ): QueryState<GetLocationsLocationIdGetData, GetLocationsLocationIdGetError> | undefined;
    /**
     * @summary Get
     * @description Retrieves a single location by its ID.
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetLocationsLocationIdGetParameters>
        | ServiceOperationInfiniteQueryKey<GetLocationsLocationIdGetSchema, GetLocationsLocationIdGetParameters>
    ):
      | QueryState<
          OperationInfiniteData<GetLocationsLocationIdGetData, GetLocationsLocationIdGetParameters>,
          GetLocationsLocationIdGetError
        >
      | undefined;
    /**
     * @summary Get
     * @description Retrieves a single location by its ID.
     */
    setQueryData(
      parameters:
        | DeepReadonly<GetLocationsLocationIdGetParameters>
        | ServiceOperationQueryKey<GetLocationsLocationIdGetSchema, GetLocationsLocationIdGetParameters>,
      updater: Updater<
        NoInfer<GetLocationsLocationIdGetData> | undefined,
        NoInfer<DeepReadonly<GetLocationsLocationIdGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetLocationsLocationIdGetData | undefined;
    /**
     * @summary Get
     * @description Retrieves a single location by its ID.
     */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<GetLocationsLocationIdGetParameters>
        | ServiceOperationInfiniteQueryKey<GetLocationsLocationIdGetSchema, GetLocationsLocationIdGetParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<GetLocationsLocationIdGetData, GetLocationsLocationIdGetParameters>> | undefined,
        | NoInfer<
            DeepReadonly<OperationInfiniteData<GetLocationsLocationIdGetData, GetLocationsLocationIdGetParameters>>
          >
        | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<GetLocationsLocationIdGetData, GetLocationsLocationIdGetParameters> | undefined;
    /**
     * @summary Get
     * @description Retrieves a single location by its ID.
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetLocationsLocationIdGetSchema,
            GetLocationsLocationIdGetData,
            TInfinite,
            GetLocationsLocationIdGetParameters,
            GetLocationsLocationIdGetError
          >
        | QueryFiltersByQueryKey<
            GetLocationsLocationIdGetSchema,
            GetLocationsLocationIdGetData,
            TInfinite,
            GetLocationsLocationIdGetParameters,
            GetLocationsLocationIdGetError
          >,
      updater: Updater<
        NoInfer<GetLocationsLocationIdGetData> | undefined,
        NoInfer<GetLocationsLocationIdGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<GetLocationsLocationIdGetData | undefined>;
    /**
     * @summary Get
     * @description Retrieves a single location by its ID.
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetLocationsLocationIdGetSchema,
        GetLocationsLocationIdGetData,
        TInfinite,
        GetLocationsLocationIdGetParameters,
        GetLocationsLocationIdGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary Get
     * @description Retrieves a single location by its ID.
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetLocationsLocationIdGetSchema,
            GetLocationsLocationIdGetData,
            TInfinite,
            GetLocationsLocationIdGetParameters,
            GetLocationsLocationIdGetError
          >
        | QueryFiltersByQueryKey<
            GetLocationsLocationIdGetSchema,
            GetLocationsLocationIdGetData,
            TInfinite,
            GetLocationsLocationIdGetParameters,
            GetLocationsLocationIdGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary Get
     * @description Retrieves a single location by its ID.
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetLocationsLocationIdGetSchema,
            GetLocationsLocationIdGetData,
            TInfinite,
            GetLocationsLocationIdGetParameters,
            GetLocationsLocationIdGetError
          >
        | QueryFiltersByQueryKey<
            GetLocationsLocationIdGetSchema,
            GetLocationsLocationIdGetData,
            TInfinite,
            GetLocationsLocationIdGetParameters,
            GetLocationsLocationIdGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary Get
     * @description Retrieves a single location by its ID.
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetLocationsLocationIdGetSchema,
            GetLocationsLocationIdGetData,
            TInfinite,
            GetLocationsLocationIdGetParameters,
            GetLocationsLocationIdGetError
          >
        | QueryFiltersByQueryKey<
            GetLocationsLocationIdGetSchema,
            GetLocationsLocationIdGetData,
            TInfinite,
            GetLocationsLocationIdGetParameters,
            GetLocationsLocationIdGetError
          >
    ): void;
    /**
     * @summary Get
     * @description Retrieves a single location by its ID.
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetLocationsLocationIdGetSchema,
            GetLocationsLocationIdGetData,
            TInfinite,
            GetLocationsLocationIdGetParameters,
            GetLocationsLocationIdGetError
          >
        | QueryFiltersByQueryKey<
            GetLocationsLocationIdGetSchema,
            GetLocationsLocationIdGetData,
            TInfinite,
            GetLocationsLocationIdGetParameters,
            GetLocationsLocationIdGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary Get
     * @description Retrieves a single location by its ID.
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetLocationsLocationIdGetSchema,
            GetLocationsLocationIdGetData,
            TInfinite,
            GetLocationsLocationIdGetParameters,
            GetLocationsLocationIdGetError
          >
        | QueryFiltersByQueryKey<
            GetLocationsLocationIdGetSchema,
            GetLocationsLocationIdGetData,
            TInfinite,
            GetLocationsLocationIdGetParameters,
            GetLocationsLocationIdGetError
          >
    ): number;
    schema: GetLocationsLocationIdGetSchema;
    types: {
      parameters: GetLocationsLocationIdGetParameters;
      data: GetLocationsLocationIdGetData;
      error: GetLocationsLocationIdGetError;
    };
  };
}
/**
 * @summary Get
 * @description Retrieves a single location by its ID.
 */
export const getLocationsLocationIdGet = {
  schema: {
    method: 'get',
    url: '/locations/{location_id}',
  },
} as {
  schema: GetLocationsLocationIdGetSchema;
  [QraftServiceOperationsToken]: LocationsService['getLocationsLocationIdGet'];
};
export const locationsService = {
  getLocationsLocationIdGet,
} as const;
type GetLocationsLocationIdGetSchema = {
  method: 'get';
  url: '/locations/{location_id}';
};
type GetLocationsLocationIdGetParameters = paths['/locations/{location_id}']['get']['parameters'];
type GetLocationsLocationIdGetData =
  paths['/locations/{location_id}']['get']['responses']['200']['content']['application/json'];
type GetLocationsLocationIdGetError =
  paths['/locations/{location_id}']['get']['responses']['422']['content']['application/json'];
